import BaseDataProcessor from './baseDataProcessor';

export default class OvercomingDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData, interval) {
    super();

    this.apiStatisticsData = apiStatisticsData;
    this.interval = interval;
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    if (this.apiStatisticsData) {
      const { days, membersCount } = this.apiStatisticsData;

      return [
        days != null ? { primaryText: days, secondaryText: 'days of overcoming' } : null,
        { primaryText: membersCount, secondaryText: 'overcomers' }
      ].filter(item => item);
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/overcomingDataProcessor.js